import React from "react"

interface FormControlsArrowKeysFixProps {
    children: React.ReactNode
}

/**
 * Wrap forms into this to enable arrow key navigation in forms when opened from a dropdown menu.
 * This doesn't work correctly and is a lib bug of ANTD
 *
 * @see https://github.com/ant-design/ant-design/issues/34125#issuecomment-2404637763
 */
export const FormControlsArrowKeysFix = ({ children }: FormControlsArrowKeysFixProps) => (
    <div
        onKeyDown={(e) => {
            if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                e.stopPropagation()
            }
        }}
    >
        {children}
    </div>
)
